import { IEnvironment } from 'src/providers/environment/types';
import { RELEASE_DETAILS } from 'src/utils/release-details';

// localhost or any deployed version for example demo-newui.vision-x.cloud
const baseUrl = window.location.hostname;
export const Environments: IEnvironment[] = [
  {
    name: 'default',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'https://' + baseUrl + '/edge/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'allQA',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'http://' + baseUrl + ':8080/edge/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'backoffice-local',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'http://' + baseUrl + ':8080/backoffice/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'backoffice-split',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'http://' + baseUrl + ':8300/backoffice/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'edge-local',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'http://' + baseUrl + ':8080/edge/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'edge-local-new',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'http://' + baseUrl + ':8083/edge/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'dev',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'http://' + baseUrl + ':8083/edge/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'edge-split',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'http://' + baseUrl + ':8400/edge/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'gusl-backoffice',
    production: true,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'http://89.163.146.165:8300/backoffice/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'gusl-edge',
    production: true,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: 'http://89.163.146.165:8400/edge/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'docker-edge',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: '/edge/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
  {
    name: 'docker-backoffice',
    production: false,
    apiKey: 'AABBCC123',
    authorisation: 'Basic YWRtaW46MTIzNDU2NyE=',
    apiBase: '/backoffice/rest',
    VERSION: RELEASE_DETAILS.releaseNumber,
  },
];
